import * as React from "react";
import { Grid } from "semantic-ui-react";
import { socialIcons, socialNetworkNames, SocialNetworksId } from "../../interfaces";
import { IconContainer, SocialIcon } from "./styled";

import "./styles.scss";
interface Props {
  networkId: SocialNetworksId;
  disabled?: boolean;
  active?: boolean;
  customIconClassname?: string;
  size?: "mini" | "big" | "large" | "noMargin" | "noMarginNoPadding";
  link?: string;
  withPadding?: boolean;
  onClickHandler?: (checked: boolean) => void;
}

export const SocialNetworkIconButton: React.FC<Props> = ({
  networkId,
  disabled = false,
  active = false,
  size = "large",
  link,
  withPadding = false,
  customIconClassname = "",
  onClickHandler,
}) => {
  return (
    <Grid.Column columns={5} className={size + "SocialIconButtonColumn"}>
      <IconContainer
        $disabled={disabled}
        data-elm-id={"socialIcon" + networkId}
        target="_blank"
        $clickable={!!(link || onClickHandler)}
        href={link}
        onClick={e => {
          if (disabled) {
            e.preventDefault();
          } else if (onClickHandler) {
            onClickHandler(!active);
          }
        }}
      >
        <SocialIcon
          custompadding={withPadding ? "3px" : "0px"}
          customsize={size}
          selected={active}
          title={socialNetworkNames[networkId]}
          src={socialIcons[networkId]}
          size="small"
          circular
          className={customIconClassname}
        />
      </IconContainer>
    </Grid.Column>
  );
};
